import {Component} from '@angular/core';

declare var jQuery:any;

@Component({
    selector: 'nomenu',
    templateUrl: 'nomenu.template.html'
})
export class nomenuComponent {}


// WEBPACK FOOTER //
// /app/src/app/layout/layouts/nomenu.component.ts